import { useEffect, useCallback, useMemo } from "react";
import styles from "./index.module.less";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useUser } from "@/utils/UserContext";
import {
  getCaseList,
  getDictIdByCode,
  getDictListById,
  getKsDict,
} from "@/services/history";
import bannerBg from "@/assets/img/player.png";

import { ButtonField, Iconsvg, Pagination } from "@wk/components-react16";
import { findValueByIdAndKey } from "@/utils";

const PersonalCases = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [userInfo, setUserInfo] = useState();
  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);

  const [historyList, setHistoryList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const getKsList = async () => {
    const res = await getKsDict();
    setKsList(res.result || []);
  };

  const zcText = useMemo(() => {
    return findValueByIdAndKey(zcList, userInfo?.zhicheng, "itemText") || "--";
  }, [zcList, userInfo]);

  const ksText = useMemo(() => {
    const value = userInfo?.keshi;
    if (!value) return "--";

    return value
      .split(",")
      .map((item) => findValueByIdAndKey(ksList, item, "title", "key"))
      .join("、");
  }, [ksList, userInfo]);

  // 点击下一页
  const onNextArrowClick = () => {
    setCurrentPage((prev) => prev + 1);
    scrollToHistoryList();
  };

  // 点击上一页
  const onPreviousClick = () => {
    setCurrentPage((prev) => prev - 1);
    scrollToHistoryList();
  };

  // 点击页码
  const onPageClick = (event) => {
    setCurrentPage(event);
    scrollToHistoryList();
  };

  const scrollToHistoryList = () => {
    const historyListElement = document.querySelector(".history-list");
    if (historyListElement) {
      historyListElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const goDetail = (id) => {
    // 跳转路由到详情页面
    navigate(`/history/detail?id=${id}`, {
      state: { path: "/player/personalCases" },
    });
  };

  const getCaseLists = async (params) => {
    const res = await getCaseList(params);
    if (res.code === 200) {
      setHistoryList(res.result.records);
      setTotal(res.result.total);
    }
  };

  const getList = useCallback(() => {
    if (!userInfo?.phone) return;

    const params = {
      pageNo: currentPage,
      pageSize: 10,
      phoneNumber: userInfo?.phone,
      px: "2",
    };
    getCaseLists(params);
  }, [userInfo, currentPage]);

  useEffect(() => {
    setUserInfo(user);
  }, [user]);

  useEffect(() => {
    getList();
  }, [userInfo, currentPage]);

  useEffect(() => {
    getZcList();
    getKsList();
  }, []);

  return (
    <div className={styles["personal-cases"]}>
      <div className="banner">
        <img src={bannerBg} alt="" />
        <div className="banner-title">{userInfo?.userName}</div>
        <div className="banner-subtitle">
          {ksText} &nbsp;&nbsp; {zcText}
        </div>
      </div>
      <div className="history-list">
        <div className="history-list-title">案例</div>
        <div className="history-list-content">
          {historyList.map((item) => (
            <div className="history-list-item" key={item.id}>
              <div className="item-title">{item.name}</div>
              <div className="item-desc">{item.description}</div>
              <div className="item-btn">
                <ButtonField iconPosition={"right"} mode={"ghost"}>
                  <button type="button" onClick={() => goDetail(item.id)}>
                    查看
                    <Iconsvg name="arrow-right"></Iconsvg>
                  </button>
                </ButtonField>
              </div>
            </div>
          ))}
        </div>

        {/* 无搜索结果提示 */}
        {historyList.length === 0 && <div className="no-data">无搜索结果</div>}

        {/* 分页 */}

        {total > 10 && (
          <div className="pagination-box">
            <Pagination
              pageIndex={currentPage}
              controlMode={"controlled"}
              pageCount={Math.ceil(total / 10)}
              onOnNextArrowClick={onNextArrowClick}
              onOnPreviousArrowClick={onPreviousClick}
              onOnPageClick={(event) => onPageClick(event)}
              visiblePagesCount={3}
              forceMobileMode={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default PersonalCases;
